<template>
  <div id="input_delivery">
    <dd-header
      :isMenuView='false'
    />
    <div class="title">
      <h1>お届け先入力</h1>
    </div>
    <div class="main_content wrapper">
      <dd-menu ref="menuRef"/>
      <div>
        <dd-flow
          :pageKey="pageKey"
          :pageList="orderForm.pageList"
        />
        <div class="input_list">
          <dd-business-input
            ref="businessInputRef"
            :label="label"
            :form="form"
          />
          <!-- <ul class="calender_list">
            <li class="input_text">
              <div>
                <label>{{label.deliveryDate}}<span class="important small_text">必須</span></label>
              </div>
            </li>
          </ul> -->
          <div class="bold">{{label.deliveryDate}}<span class="important small_text">必須</span></div>
          <div class="list_day">
            <dd-calendar
              :schedule="schedule"
              :value="form.deliveryDate"
              @selectedDate="selectedDate"
            />
            <div id="delivery_time">
              <div class="radio_check">
                <input type="radio" name="target_time" id="time1" checked="" value=0 v-model.number="form.selectTime" />
                <label for="time1" class="radio-label">なし</label>
              </div>
              <div class="radio_check">
                <input type="radio" name="target_time" id="time2" value=1 v-model.number="form.selectTime" />
                <label for="time2" class="radio-label">午前（8:00～12:00）</label>
              </div>
              <div class="radio_check">
                <input type="radio" name="target_time" id="time3" value=2 v-model.number="form.selectTime" />
                <label for="time3" class="radio-label">午前（12:00～15:00）</label>
              </div>
            </div>
            <!-- <div class="time">
              <ul>
                <template v-if="mkid == 1">
                  <li>
                    <input type="radio" id="time0" name="target_time" :value="0" v-model="form.selectTime"/>
                    <label for="time0">指定なし</label>
                  </li>
                  <li>
                    <input type="radio" id="time1" name="target_time" :value="1" v-model="form.selectTime"/>
                    <label for="time1">午前中(8:00～12:00)</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="2" v-model="form.selectTime"/>
                    <label for="time2">午後(12:00～15:00)</label>
                  </li>
                </template>
                <template v-else-if="mkid == 2">
                </template>
                <template v-else>
                  <li>
                    <input type="radio" id="time0" name="target_time" :value="0" v-model="form.selectTime"/>
                    <label for="time0">指定なし</label>
                  </li>
                  <li>
                    <input type="radio" id="time1" name="target_time" :value="3" v-model="form.selectTime"/>
                    <label for="time1">10:00～12:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="4" v-model="form.selectTime"/>
                    <label for="time2">12:00～14:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="5" v-model="form.selectTime"/>
                    <label for="time2">14:00～16:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="6" v-model="form.selectTime"/>
                    <label for="time2">16:00～18:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="7" v-model="form.selectTime"/>
                    <label for="time2">18:00～20:00</label>
                  </li>
                </template>
              </ul>
            </div> -->
          </div>
          <div v-if="errors.deliveryDate" class="error_text">{{errors.deliveryDate}}</div>
          <ul>
            <li class="input_text">
              <div>
                <label class="list_key">{{label.message}}</label>
              </div>
              <textarea class="list_box" v-model="form.message" cols="100" rows="5" maxlength="256" placeholder="配送時の連絡事項をご記入ください。"/>
            </li>
            <!-- <li v-if="!isGuestUser">
              <div class="check_box">
                <input type="checkbox" id="registAddress" v-model="form.isRegistAddress"/>
                <label for="registAddress">納品先を登録する。</label>
              </div>
            </li> -->
          </ul>
        </div>
        <div class="input_error_field">
          <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        </div>
        <div class="input_list" v-if="mkid===1">
          <div class="title_bold">配送時の注意事項</div>
          <div>
            ■ 集合住宅や店舗などの場合<br/>
            エレベーターがある場合 : 玄関前渡し<br/>
            エレベーターが無い場合 : 共有部エントランス前渡し<br/>
            <br/>
            ■ 戸建の場合<br/>
            玄関前渡し<br/>
            <br/>
            いずれの場合も原則置き便は出来ません。受取人様をご指定ください。<br/>
          </div>
        </div>
        <div class="control_btn_area">
          <div class="detail_btn2" @click="onPrev()">もどる</div>
          <div class="detail_btn" :disabled="!isConfirm" @click="confirm()">{{successLabel}}</div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Calendar from '../../components/common/Calendar'
import LoadingModal from '../../components/common/LoadingModal'
// Module
import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import DcMenu from '../components/top/DcLeftMenu'
import Flow from '../components/common/Flow'
import BusinessInput from '../components/order/DcBusinessInput'
import ToolTip from '../../components/common/ToolTip'

export default {
  name: 'DcOrderInput',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-menu': DcMenu,
    'dd-flow': Flow,
    'dd-calendar': Calendar,
    'dd-loading-modal': LoadingModal,
    'dd-business-input': BusinessInput,
    'tool-tip': ToolTip
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'orderInput',
      form: {
        businessId: '',
        businessName: '',
        building: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        deliveryDate: '',
        message: '',
        selectTime: 0,
        isRegistAddress: false
      },
      // 入力保持用のフォーム
      topForm: {},
      orderForm: {},
      // 画面表示項目
      label: {
        businessName: '施主名(物件名)',
        building: '納品先名',
        postcd: '納品先郵便番号',
        address: '納品先住所',
        state: '住所',
        street: '以下、住所',
        userName: '受取人氏名',
        userNameKana: '受取人氏名（カナ）',
        tel: '受取人電話番号',
        deliveryDate: '納品希望日',
        message: '配送時の連絡事項'
      },
      errors: {},
      validateErrorMessages: {},
      schedule: {},
      inputFlag: false,
      imgQmark: this.getImage('common/qmark_gray.svg'),
      paymentType: 0
    }
  },
  methods: {
    scheduling: function () {
      let payload = {
        params: {
          paymentType: this.paymentType
        }
      }
      axios.get(DC_URL.SCHEDULE + '/delivery', payload)
        .then(response => {
          this.schedule = response.data.data
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    selectedDate: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.deliveryDate = format
    },
    confirm: function () {
      // 入力チェック
      let retBusinessErr = this.$refs.businessInputRef.confirm()
      this.errors = {}
      this.validateRequire()
      if (!retBusinessErr || Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      // 多重防止
      if (this.inputFlag) return
      this.inputFlag = true
      this.$refs.loadingModalRef.showModal(true)
      App.setLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA, this.form)
      axios.post(DC_URL.ORDER + '/input', this.form)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
            this.$refs.loadingModalRef.showModal(false)
          } else {
            // 確認画面へ
            if (this.isGuestUser) {
              this.$router.push({
                name: 'DcOrderGuest'
              })
            } else if (this.orderForm.workFlag) {
              this.$router.push({
                name: 'ConstructInput'
              })
            } else {
              this.$router.push({
                name: 'OrderConfirm'
              })
            }
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.inputFlag = false
        })
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      if (Object.keys(lform).length > 0) {
        this.form = Object.assign({}, lform)
      }
      let ltop = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      if (Object.keys(ltop).length > 0) {
        this.topForm = Object.assign({}, ltop)
      }
      let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      if (Object.keys(lorder).length > 0) {
        this.orderForm = Object.assign({}, lorder)
      }
    },
    validateRequire: function () {
      if (!this.form.deliveryDate) this.errors['deliveryDate'] = this.label.deliveryDate + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isDate(this.form.deliveryDate)) {
        this.errors['deliveryDate'] = this.label.deliveryDate + 'の日付の形式が間違っています。'
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    onPrev: function () {
      this.$router.go(-1)
    }
  }, // end method
  computed: {
    isConfirm: function () {
      if (this.form.postcd && this.form.state && this.form.city && this.form.street) {
        return true
      }
      return false
    },
    mkid: function () {
      if (this.orderForm.corpId === 27) return 1
      if (this.orderForm.corpId === 1070) return 2
      return 0
    },
    isGuestUser: function () {
      if (!this.userInfo || this.userInfo.userLevel === 4) {
        return true
      }
      return false
    },
    successLabel: function () {
      if (this.isGuestUser) {
        return '発注者情報入力'
      } else if (this.orderForm.workFlag) {
        return '設置情報入力'
      } else {
        return 'ご注文内容確認'
      }
    }
  },
  watch: {
  },
  mounted () {
    this.scheduling()
  },
  created () {
    this.fetchData()
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    // paymentType指定時のみ
    let lPaymentType = App.getLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)
    if (Check.isNumber(lPaymentType)) {
      this.paymentType = Number(lPaymentType)
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcOrderInput.vue